import FuzerIcon from '../../assets/icons/fuzer-loader-icon.svg'

const AppLoader = () => (
	<img className='absolute top-0 bottom-0 left-0 right-0 m-auto rounded-full h-[100px] animate-spin' src={FuzerIcon} alt="app loader" />
) 

export default AppLoader